var map = {
	"./BuildingTemplate": 45,
	"./BuildingTemplate.json": 45,
	"./CardTemplate": 10,
	"./CardTemplate.json": 10,
	"./FloorTemplate": 34,
	"./FloorTemplate.json": 34,
	"./HelperClauses": 14,
	"./HelperClauses.json": 14,
	"./LandingTemplate": 63,
	"./LandingTemplate.json": 63,
	"./LoginTemplate": 64,
	"./LoginTemplate.json": 64,
	"./OnboardBuildingTemplate": 94,
	"./OnboardBuildingTemplate.json": 94,
	"./OnboardRoomTemplate": 95,
	"./OnboardRoomTemplate.json": 95,
	"./OnboardUserTemplate": 96,
	"./OnboardUserTemplate.json": 96,
	"./OrgTemplate": 65,
	"./OrgTemplate.json": 65,
	"./RequestAccessTemplate": 97,
	"./RequestAccessTemplate.json": 97,
	"./RoomTemplate": 35,
	"./RoomTemplate.json": 35,
	"./SettingsTemplate": 40,
	"./SettingsTemplate.json": 40
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98;


//////////////////
// WEBPACK FOOTER
// ./src/lib/langTemplates ^\.\/.*$
// module id = 98
// module chunks = 1